<details class="w-full rounded-3xl bg-white group" #detailsElement>
  <summary
    class="flex justify-between font-bold p-[2.5rem] cursor-pointer bg-vinciLavender rounded-3xl group-open:rounded-b-none"
  >
    <h3>{{ title() }}</h3>
    <span
      class="flex items-center justify-center flex-shrink-0 h-10 w-10 no-print rounded-full bg-vinciBlue-150 group-hover:bg-vinciBlue-250 transition-colors duration-200"
    >
      <icon [name]="'nav-arrow-down'" class="icon-closed"></icon>
      <icon [name]="'nav-arrow-up'" class="icon-open"></icon>
    </span>
  </summary>
  @if (section().questions.length !== 0) {
  <div class="p-[2.5rem] flex flex-col gap-[2.5rem]">
    @for(question of section().questions; track $index; let questionIdx =
    $index){
    <div class="flex flex-col gap-[1.5rem]">
      <h4 class="!font-normal">{{ question.question }}</h4>
      @if(question.answerType === 'text'){
      <textarea
        class="border border-vinciLavender-400 text-vinciGrey-500 rounded-lg px-[1rem] py-[0.5rem] resize-none"
        rows="3"
        placeholder="{{ 'components.questionnaireSection.textAnswerPlaceholder' | transloco }}"
        [value]="getAnswer(questionIdx)"
        (input)="setAnswer(questionIdx, $event.target.value)"
      ></textarea>
      } @else if (question.answerType =='radio') {
      <div class="flex flex-col gap-[1rem]">
        @for(choice of question.answerChoices; track $index) {
        <label class="flex items-center gap-[1.5rem] cursor-pointer w-fit">
          <input
            type="radio"
            [name]="'question-' + sectionIndex() + '-' + questionIdx"
            [value]="$index.toString()"
            [checked]="compareRadioButtonAnswerWithAnswerIndex($index, getAnswer(questionIdx))"
            (change)="setAnswer(questionIdx, $index.toString())"
            class="custom-radio appearance-none flex-shrink-0 w-[1.25rem] h-[1.25rem] border-2 border-vinciGrey-300 rounded-full bg-white hover:bg-vinciBlue-150 checked:bg-vinciBlue-400 checked:border-vinciGrey-300 checked:before:content-[''] checked:before:block checked:before:w-[0.5rem] checked:before:h-[0.5rem] checked:before:rounded-full checked:before:mx-auto checked:before:my-[0.25rem] focus:outline-none focus:ring-2 focus:ring-vinciBlue-200 transition-all duration-200"
          />
          <span class="text-base">{{ choice }}</span>
        </label>
        }
      </div>
      } @else if (question.answerType == 'multichoice') {
      <div class="flex flex-col gap-[1rem]">
        @for(choice of question.answerChoices; track $index) {
        <label class="flex items-center gap-[1.5rem] cursor-pointer w-fit">
          <input
            type="checkbox"
            [name]="'question-' + sectionIndex() + '-' + questionIdx + '-checkbox'"
            [checked]="isMultiChoiceSelected(questionIdx, $index)"
            (change)="onMultiChoiceChange(questionIdx, $index, $any($event.target).checked)"
            class="flex-shrink-0 w-[20px] h-[20px] border-2 border-vinciGrey-300 rounded bg-white hover:bg-vinciBlue-150 checked:bg-vinciBlue-400 checked:border-vinciGrey-300 focus:outline-none focus:ring-2 focus:ring-vinciBlue-200 transition-all duration-200"
          />
          <span class="text-base">{{ choice }}</span>
        </label>
        }
      </div>
      }
    </div>
    }
    <button
      class="cta self-end text-vinciBlue-600 no-print !border !border-vinciBlue-300 rounded-lg px-3 py-1"
      (click)="saveAnswers()"
      [disabled]="isSaving()"
    >
      @if (!isSaving()) { {{ 'questionnairePage.questionnaireSectionSaveText' | transloco }}
      <icon [name]="'save-file'" [size]="'1rem'" class="mb-[0.125rem]"></icon>
      } @else { {{ 'questionnairePage.questionnaireSectionSavingText' | transloco }} }
    </button>
  </div>
  }
</details>
